import React, { useState, useEffect } from 'react';
import './ChatbotButton.css';

const ChatbotButton = ({ contrato_metacid, num_contrato }) => {
    const [showBubble, setShowBubble] = useState(false);
    const [chatbotUrl, setChatbotUrl] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const whatsappIcon = `${process.env.PUBLIC_URL}/images/whatsapp-icon.png`;

    // Obtener el número de contrato desde props
    const getContrato = () => {
        return num_contrato || contrato_metacid;
    };

    const CONFIG = {
        apiBaseUrl: process.env.REACT_APP_API_DM_URL,
        endpoints: {
            getChatbotUrl: '/api/chatbot/url',
            validateContract: '/api/chatbot/validar-contrato',
            registerCounter: '/api/registrar_contador'
        },
        module: 'chatbot'
    };

    /**
     * Obtener URL del chatbot desde la API
     */
    const fetchChatbotUrl = async () => {
        try {
            const response = await fetch(`${CONFIG.apiBaseUrl}${CONFIG.endpoints.getChatbotUrl}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.json();
            if (data.status === 'success' && data.url_web) {
                console.log('[Chatbot] URL obtenida correctamente');
                return data.url_web;
            } else {
                console.warn('[Chatbot] No se pudo obtener URL:', data);
                return null;
            }
        } catch (error) {
            console.error('[Chatbot] Error al obtener URL:', error);
            return null;
        }
    };

    /**
     * Validar si el contrato es apto para el chatbot
     */
    const validateContract = async () => {
        const token = localStorage.getItem('token');
        const contrato = getContrato();
        
        if (!token || !contrato) {
            console.warn('[Chatbot] Token o contrato no encontrados');
            console.log('[Chatbot] Token:', token ? 'OK' : 'Missing');
            console.log('[Chatbot] Contrato:', contrato || 'Missing');
            return false;
        }

        try {
            const response = await fetch(`${CONFIG.apiBaseUrl}${CONFIG.endpoints.validateContract}`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ contrato: String(contrato) })
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.json();
            console.log('[Chatbot] Respuesta de validación:', data);
            
            if (data.status === 'success') {
                const isApto = data.es_apto === true || data.es_apto === 'true';
                console.log(`[Chatbot] es_apto: ${data.es_apto}, isApto final: ${isApto}`);
                
                if (!isApto) {
                    console.log(`[Chatbot] ❌ Contrato NO APTO`);
                    return false;
                }
                
                console.log(`[Chatbot] ✅ Contrato APTO`);
                return true;
            } else {
                console.warn('[Chatbot] Error en validación:', data);
                return false;
            }
        } catch (error) {
            console.error('[Chatbot] Error validando contrato:', error);
            return false;
        }
    };

    /**
     * Registrar uso del módulo chatbot
     */
    const registerCounter = async () => {
        const token = localStorage.getItem('token');
        const contrato = getContrato();
        
        if (!token || !contrato) {
            console.warn('[Chatbot] No se pudo registrar contador: token o contrato ausentes');
            return false;
        }

        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 2000);
            
            const url = `${CONFIG.apiBaseUrl}${CONFIG.endpoints.registerCounter}`;
            console.log('[Chatbot] Registrando contador...');
            
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    contrato: String(contrato),
                    modulo: CONFIG.module
                }),
                signal: controller.signal
            });

            clearTimeout(timeoutId);
            
            if (!response.ok) {
                console.warn('[Chatbot] HTTP error:', response.status);
                return false;
            }

            const data = await response.json();
            console.log('[Chatbot] ✅ Contador registrado:', data.message);
            return true;
        } catch (error) {
            console.warn('[Chatbot] Error registrando contador:', error.message);
            return false;
        }
    };

    /**
     * Inicializar chatbot
     */
    useEffect(() => {
        const initChatbot = async () => {
            const contrato = getContrato();
            
            if (!contrato) {
                return;
            }

            // Obtener URL del chatbot
            const url = await fetchChatbotUrl();
            if (!url) {
                return;
            }

            setChatbotUrl(url);

            // Validar contrato
            const isValid = await validateContract();
            if (!isValid) {
                return;
            }

            setIsVisible(true);
            setShowBubble(true);
        };

        initChatbot();
    }, [contrato_metacid, num_contrato]);

    /**
     * Manejar click en el botón de chatbot
     */
    const handleChatbotClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        console.log('[Chatbot] ✅ Click detectado');
        setIsLoading(true);

        // Registrar contador
        await registerCounter();

        // Abrir WhatsApp con URL nativa
        if (chatbotUrl) {
            console.log('[Chatbot] Abriendo WhatsApp:', chatbotUrl);
            window.open(chatbotUrl, '_blank');
        }

        setIsLoading(false);
    };

    const handleCloseBubble = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowBubble(false);
    };

    if (!isVisible) return null;

    return (
        <div className="chatbot-btn-container">
            <button
                id="chatbot-floating-btn"
                className="chatbot-float"
                title="Chat con nosotros"
                onClick={handleChatbotClick}
                disabled={isLoading}
            >
                <img
                    src={whatsappIcon}
                    alt="WhatsApp Chatbot"
                    className="chatbot-icon"
                />
            </button>

            {showBubble && (
                <div className={`chatbot-bubble ${showBubble ? 'show' : ''}`}>
                    <button
                        className="chatbot-bubble-close"
                        onClick={handleCloseBubble}
                    >
                        ✕
                    </button>
                    <div className="chatbot-bubble-content">
                        Hola soy Ada<br />
                        ¿Cómo te puedo apoyar?
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatbotButton;
